import React from 'react'
import Box from '@material-ui/core/Box'
import useSettingsStyles from 'pages/pga-coach/settings/settings.styles'
import {
  SettingsLinkRow,
  SettingsSection,
} from 'pages/pga-coach/settings/settings-components'
import AccountCard from 'pages/account/account-details/account-card'
import useAccountDetailsStyles from 'pages/account/account-details/styles'
import AccountLinkRow from 'components/account-link-row'
import { PageHeader } from 'components/page-header'
import { usePortal } from 'lib/portal'
import SchoolOutlinedIcon from 'components/material-symbol/icons/School'
import EventNoteOutlinedIcon from 'components/material-symbol/icons/EventNote'
import { GolferIcon } from 'components/icons/refreshed-icons'
import PeopleAltOutlined from 'components/material-symbol/icons/PeopleAlt'
import ThreePOutlinedIcon from 'components/material-symbol/icons/ThreeP'
import MenuBookOutlinedIcon from 'components/material-symbol/icons/MenuBook'

const COACH_TRAINING_CENTER_URL = 'https://pgacoach.lightspeedvt.com/'

const ADM_PARENT_COMMUNICATION_URL =
  'https://sites.google.com/pgahq.com/adm-communication-guide'

const DIGITAL_PLAYBOOK_URL =
  'https://support.pga.com/en/articles/10365690-pga-coach-digital-playbook'

const HELP_CENTER_URL =
  'https://support.pga.com/en/collections/2683103-pga-members'

const TrainingAndResourcesPage = () => {
  const [target] = usePortal()
  const settingsStyles = useSettingsStyles()
  const accountClasses = useAccountDetailsStyles()

  return (
    <>
      <PageHeader title="Training & Resources" actions={target} />
      <Box className={settingsStyles.contentContainer}>
        <SettingsSection eyebrow="Training" classes={settingsStyles}>
          <SettingsLinkRow
            href={COACH_TRAINING_CENTER_URL}
            icon={<SchoolOutlinedIcon />}
            title="Coach Training Center"
            description="Online courses to grow your coaching skills and business."
            classes={settingsStyles}
          />
        </SettingsSection>

        <SettingsSection eyebrow="Resources" classes={settingsStyles}>
          <SettingsLinkRow
            to="training-resources/activity-plans/fundamental-movement-skills/activities"
            icon={<GolferIcon size={16} color="#172024" />}
            title="Fundamental Movement Skills"
            description="Movement skill assessments and coaching cues for your athletes."
            classes={settingsStyles}
          />
          <SettingsLinkRow
            to="training-resources/activity-plans"
            icon={<EventNoteOutlinedIcon />}
            title="Activity Plans"
            description="Featured activities and lesson plans for your programs."
            classes={settingsStyles}
          />
          <SettingsLinkRow
            href={ADM_PARENT_COMMUNICATION_URL}
            icon={<PeopleAltOutlined />}
            title="ADM Parent Communication"
            description="Email templates, videos, and images to explain ADM to families."
            classes={settingsStyles}
          />
          <SettingsLinkRow
            href={DIGITAL_PLAYBOOK_URL}
            icon={<MenuBookOutlinedIcon />}
            title="Digital Playbook"
            description="Digital tools and strategies to grow your coaching business online."
            classes={settingsStyles}
          />
        </SettingsSection>

        <AccountCard title="Help Center" classes={accountClasses}>
          <AccountLinkRow
            href={HELP_CENTER_URL}
            icon={<ThreePOutlinedIcon />}
            title="PGA Coach Help Center"
            description="Find answers and guides for using PGA Coach."
          />
        </AccountCard>
      </Box>
    </>
  )
}

export default TrainingAndResourcesPage
